import CatalogsLayout from "Components/CatalogsLayout";
import Grid, { SelectColumnFilter, TextFilter } from "Components/Grid";
import Layout from 'Layout'
import { CSSProperties, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import Buttons from "Components/Buttons";
import { IBrand } from "Interfaces/IBrand";
import Modal from "Components/V1/Modal";
import ServiceArchivo from "service/archivos";
import MenuFilter from "Components/V1/ModalComponents/CargaArchivos/MenuFilter";
import { downloadURI, formatDateWithoutTime } from "utils";
import CreateNewFile from "Components/V1/ModalComponents/CargaArchivos/Create";
import { ErrorContainer, VersionContainer } from "./styled.components";
import VersionsFile from "Components/V1/ModalComponents/CargaArchivos/Versions";
import { FaCircleExclamation } from "react-icons/fa6";
import { Tooltip } from "@mui/material";
import { FaClockRotateLeft } from "react-icons/fa6";

const typeModal: any = Object.freeze({
  NEW: "NEW",
  VERSION: 'VERSION'
});

// @ts-nocheck
const CargaArchivos = () => {
  const { catalogs } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);



  const [data, setData] = useState([])
  const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [action, setAction] = useState<string>("");
  const [errors, setErrors] = useState<IBrand>({});
  const [formValues, setFormValues] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);




  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [componentActual, setComponentActual] = useState<string>('');
  const [selected, setSelected] = useState<any>();
  const [filters, setFilters] = useState<any>({});

  useEffect(() => {
    getAll();

  }, [filters])

  const getAll = () => {
    ServiceArchivo.getHistorico({ setterFunc: setData, params: filters });
  }
  const handleNew = () => {
    setComponentActual(typeModal.NEW);
    setTitle("Carga de Archivo");
    handleChange(true)();
  };
  const handleVersion = (row: any) => {
    setComponentActual(typeModal.VERSION);
    setSelected(row);
    setTitle("Histórico de versiones");
    handleChange(true)();
  };
  const downloadFile = (row: any) => {
    downloadURI(row.fullPath, row.url)
  }
  const handleChange = (option: boolean = false) => (e?: any) => { setOpen(option) };


  const handleFilters = (data: any) => {
    setFilters(data);
  }









  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: catalogs.background,
  };

  const columns = [
    {
      accessor: "idCargaArchivo",
      Header: "ID",
    },
    {
      accessor: "nombreArchivo",
      Header: "Nombre de Archivo",
    },
    {
      accessor: "prefijo",
      Header: "Prefijo",
    },
    {
      accessor: "marcaTipoOperacion",
      Header: "Marca-Tipo Op",
    },
    {
      accessor: "fechaCarga",
      Header: "Fecha de carga",
      Cell: (info: any) => {
        return formatDateWithoutTime(info.value)
      }
    },
    {
      accessor: "fechaAplicacion",
      Header: "Fecha de aplicación",
      Cell: (info: any) => formatDateWithoutTime(info.value)
    },
    {
      accessor: "version",
      Header: "Versión",
      Cell: (info: any) => (
        <VersionContainer>
          {info.value}
          {info.row.original.version !== 'V1' && <FaClockRotateLeft onClick={() => handleVersion(info.row.original)} /> }
        </VersionContainer>
      )
    },
    {
      accessor: "estatus",
      Header: "Estatus",
      Cell: (info: any) => (
        info.row.original.idEstatus === 4 || info.row.original.idEstatus === 6
          ? (
            <Tooltip title={info.row.original.resultadoProcesamiento}>
              <ErrorContainer>
                {info.value}
                <FaCircleExclamation />
              </ErrorContainer >
            </Tooltip>
          )
          : (
              <>{info.value}</>
          )
      )
    },
  ];
  const config: any = {
    actions: [
      {
        action: "Download",
        tooltip: "Descargar",
        visible: true,
        handle: downloadFile,
        color: "#2f971a",
        icon: "downloadForOffline",
      },
    ],
  };

  return (
    <Layout theme={styles}>
      <>
        <CatalogsLayout bannerTitle={'Carga de Data - Histórico'}>
          <Grid columns={columns} data={data} config={config} isLoading={isLoadingGrid}>
            <Buttons
              title={"Actualizar"}
              type={"add-catalog"}
              config={btnSimple}
              handleClick={getAll}
            />
            <Buttons
              title={"Agregar"}
              type={"add-catalog"}
              config={btnSimple}
              handleClick={handleNew}
            />
            <MenuFilter handleFilters={handleFilters} />
          </Grid>
          <Modal
            title={title}
            open={open}
            handleChange={handleChange}
            loader={loading}
            size="60vw"
          >
            {componentActual === typeModal.NEW && (
              <CreateNewFile
                reloadData={getAll}
                closeModal={() => {
                  setComponentActual("");
                  setOpen(false);
                }}
                loading={loading}
                setLoading={setLoading}
              />
            )}
            {componentActual === typeModal.VERSION && (
              <VersionsFile
                closeModal={() => {
                  setComponentActual("");
                  setOpen(false);
                }}
                row={selected}
              />
            )}



          </Modal>
        </CatalogsLayout>
      </>
    </Layout>
  )
}

export default CargaArchivos